module.exports = new __parcel__URL__("the-empire-strikes-back.6a8e54c0.jpg").toString();